var _rect, _g, _path, _path2, _g2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgLegalProtectionInsurance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 106,
    viewBox: "0 0 112 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 106,
    fill: "#E5E5E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_40_2721)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-39 -14C-39 -20.6274 -33.6274 -26 -27 -26H139C145.627 -26 151 -20.6274 151 -14V161.231C151 167.858 145.627 173.231 139 173.231H-27C-33.6274 173.231 -39 167.858 -39 161.231V-14Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M111.375 53.5C111.375 82.4949 87.8699 106 58.875 106C29.8801 106 6.375 82.4949 6.375 53.5C6.375 24.5051 29.8801 1 58.875 1C87.8699 1 111.375 24.5051 111.375 53.5Z",
    fill: "#D6E8F6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_40_2721",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 1,
    width: 106,
    height: 105
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M111.375 53.5C111.375 82.4949 87.8699 106 58.875 106C29.8801 106 6.375 82.4949 6.375 53.5C6.375 24.5051 29.8801 1 58.875 1C87.8699 1 111.375 24.5051 111.375 53.5Z",
    fill: "#D6E8F6"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_40_2721)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.241 38.0344C78.0294 38.0344 77.8231 37.9724 77.6477 37.8548C75.7353 36.5763 73.4862 35.8954 71.1859 35.8965H46.8189C44.5163 35.8944 42.2662 36.5753 40.3516 37.8548C40.032 38.0654 39.6257 38.091 39.2827 37.9221L35.0068 35.7842L35.9625 33.8707L39.7038 35.7392C41.8503 34.4426 44.311 33.7573 46.8189 33.7584H71.1859C73.6968 33.7563 76.1598 34.4416 78.3083 35.7392L82.0444 33.8707L83 35.7842L78.7241 37.9221C78.5745 37.997 78.4088 38.0354 78.241 38.0344Z",
    fill: "#4B81AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9651 84H44.0342C44.0342 81.6386 45.9486 79.7241 48.31 79.7241H69.6892C72.0506 79.7241 73.9651 81.6386 73.9651 84Z",
    fill: "#2C3A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.6894 79.7241H61.1377C63.4991 79.7241 65.4136 81.6386 65.4136 84H73.9653C73.9653 81.6386 72.0508 79.7241 69.6894 79.7241Z",
    fill: "#0C1327"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4135 79.7239H52.5859L56.8618 75.4481H61.1377L65.4135 79.7239Z",
    fill: "#2C3A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1382 30.5516H56.8623V75.448H61.1382V30.5516Z",
    fill: "#4B81AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1378 30.5516H56.8619L55.7609 26.1486C55.313 24.3603 56.4002 22.5472 58.1896 22.0994C58.4547 22.0331 58.7273 22 58.9998 22C60.8438 22 62.3382 23.4944 62.3382 25.3384C62.3382 25.612 62.3051 25.8835 62.2388 26.1486L61.1378 30.5516Z",
    fill: "#2C3A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9998 22.0002C58.6588 22.0056 58.321 22.0634 57.9971 22.1713C59.6774 22.6973 60.6578 24.4407 60.2333 26.149L59.1334 30.552H61.1377L62.2387 26.149C62.6866 24.3606 61.5994 22.5476 59.81 22.0998C59.546 22.0345 59.2735 22.0002 58.9998 22.0002Z",
    fill: "#0C1327"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3448 29.4829H53.6553V31.6208H64.3448V29.4829Z",
    fill: "#2C3A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0993 59.9566L39.7581 37.393L29.4169 59.9566C29.1711 60.4932 28.5362 60.7284 27.9994 60.4826C27.4628 60.2367 27.2276 59.6018 27.4734 59.0652L38.7863 34.3818C39.0321 33.8452 39.6671 33.61 40.2038 33.856C40.4368 33.9628 40.6228 34.1489 40.7298 34.3818L52.0426 59.0652C52.2885 59.6018 52.0534 60.2367 51.5166 60.4826C50.98 60.7295 50.3461 60.4932 50.0993 59.9566Z",
    fill: "#B0D2EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5817 59.9569L78.2405 37.3933L67.8993 59.9569C67.6535 60.4935 67.0186 60.7287 66.4818 60.4829C65.9452 60.237 65.71 59.6021 65.9559 59.0655L77.2687 34.3821C77.5145 33.8455 78.1495 33.6103 78.6861 33.8563C78.9191 33.9631 79.1051 34.1492 79.2121 34.3821L90.5249 59.0655C90.7708 59.6021 90.5357 60.237 89.9989 60.4829C89.4625 60.7298 88.8285 60.4935 88.5817 59.9569Z",
    fill: "#B0D2EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4824 60.4826H89.9995C89.9995 64.0252 87.1283 66.8964 83.5857 66.8964H72.8961C69.3547 66.8963 66.4824 64.0251 66.4824 60.4826Z",
    fill: "#2C3A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5857 60.4826C83.5857 64.0252 80.7145 66.8964 77.1719 66.8964H83.5857C87.1283 66.8964 89.9995 64.0252 89.9995 60.4826H83.5857Z",
    fill: "#0C1327"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 60.4826H51.5171C51.5171 64.0252 48.6459 66.8964 45.1033 66.8964H34.4137C30.8723 66.8963 28 64.0251 28 60.4826Z",
    fill: "#2C3A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1032 60.4826C45.1032 64.0252 42.232 66.8964 38.6895 66.8964H45.1032C48.6458 66.8964 51.517 64.0252 51.517 60.4826H45.1032Z",
    fill: "#0C1327"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 6.27543C0 5.93148 0.291786 5.64485 0.664196 5.6341C0.779375 5.63051 11.8634 5.25789 18.3595 0.163032C18.6282 -0.0519407 19.0237 -0.0555235 19.2924 0.15945L19.2963 0.163032C25.7923 5.26148 36.8495 5.6341 36.9608 5.63768C37.3294 5.64843 37.625 5.93148 37.625 6.27902V6.32918C37.625 15.1861 36.0739 27.5685 28.4261 36.2427C23.7959 41.4952 19.2079 42.8782 19.0121 42.9355L18.8048 43L18.5898 42.9355C18.394 42.8782 13.8329 41.4952 9.20277 36.2427C1.55107 27.5649 0 15.1861 0 6.32559V6.27543Z",
    fill: "#3A8761"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5735 21.0833L16.7399 25.0842C17.1272 25.4561 17.739 25.4557 18.1259 25.0834L27.1772 16.373C27.8312 15.7436 27.8312 14.6969 27.1772 14.0675C26.5578 13.4714 25.578 13.4714 24.9586 14.0675L17.43 21.3126L14.7896 18.776C14.1695 18.1803 13.1894 18.1814 12.5706 18.7786C11.9178 19.4086 11.9191 20.4549 12.5735 21.0833Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_40_2721",
    x: -59,
    y: -42,
    width: 230,
    height: 239.231,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.254902 0 0 0 0 0.239216 0 0 0 0 0.270588 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_40_2721"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_40_2721",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgLegalProtectionInsurance);
export default __webpack_public_path__ + "static/media/imgLegalProtectionInsurance.e5e534fa3e3aacfc75e41de63824bb8c.svg";
export { ForwardRef as ReactComponent };